import app from 'flarum/forum/app';
import IndexPage from 'flarum/forum/components/IndexPage';
import Page from 'flarum/common/components/Page';
import Button from 'flarum/common/components/Button';
import BlogCategories from '../components/BlogCategories';
import Link from 'flarum/common/components/Link';
import ForumNav from '../components/ForumNav';
import BlogOverviewItem from '../components/BlogOverviewItem';
import FeaturedBlogItem from '../components/FeaturedBlogItem';
export default class BlogOverview extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    app.setTitle(app.translator.trans('v17development-flarum-blog.forum.blog'));
    this.bodyClass = 'BlogOverviewPage';
    this.isLoading = true;
    this.featuredPosts = [];
    this.posts = [];
    this.hasMore = null;
    this.isLoadingMore = false;
    this.languages = app.store.all('discussion-languages');
    this.currentSelectedLanguage = m.route.param('lang') ? m.route.param('lang') : app.translator.formatter.locale;
    this.currentCategorySlug = m.route.param('slug') || null;
    this.currentRouteLanguage = m.route.param('lang') || null;

    // Send history push
    app.history.push('blog');
    this.featuredCount = parseInt(app.forum.attribute('blogFeaturedCount'), 10) || 0;
    this.loadBlogOverview();
    this.showCategories = true;
    this.showForumNav = true;
  }
  onbeforeupdate(vnode) {
    super.onbeforeupdate(vnode);
    const categorySlug = m.route.param('slug') || null;
    const routeLanguage = m.route.param('lang') || null;
    if (categorySlug !== this.currentCategorySlug || routeLanguage !== this.currentRouteLanguage) {
      this.currentCategorySlug = categorySlug;
      this.currentRouteLanguage = routeLanguage;
      this.currentSelectedLanguage = routeLanguage || app.translator.formatter.locale;
      this.isLoading = true;
      this.isLoadingMore = false;
      this.featuredPosts = [];
      this.posts = [];
      this.hasMore = null;
      this.reloadData();
    }
  }

  // Load blog overview
  loadBlogOverview() {
    const preloadBlogOverview = app.preloadedApiDocument();
    if (preloadBlogOverview) {
      // We must wrap this in a setTimeout because if we are mounting this
      // component for the first time on page load, then any calls to m.redraw
      // will be ineffective and thus any configs (scroll code) will be run
      // before stuff is drawn to the page.
      setTimeout(this.show.bind(this, preloadBlogOverview), 0);
    } else {
      this.reloadData();
    }
    m.redraw();
  }
  requestParams(offset) {
    if (offset === void 0) {
      offset = 0;
    }
    const filter = {
      blog: true
    };
    const categorySlug = m.route.param('slug');
    if (categorySlug) {
      filter.tag = categorySlug;
    }
    if (this.languages !== null && this.languages.length >= 1) {
      filter.language = this.currentSelectedLanguage;
    }
    return {
      filter,
      sort: '-createdAt',
      page: {
        offset
      }
    };
  }
  reloadData() {
    app.store.find('discussions', this.requestParams()).then(this.show.bind(this)).catch(() => m.redraw());
  }

  // Show blog posts
  show(articles) {
    var _articles$payload$lin;
    this.hasMore = (_articles$payload$lin = articles.payload.links) != null && _articles$payload$lin.next ? true : null;
    this.featuredPosts = articles.slice(0, this.featuredCount);
    this.posts = articles.length > this.featuredCount ? articles.slice(this.featuredCount) : [];
    this.isLoading = false;
    m.redraw();
  }

  // Load more blog posts
  loadMore() {
    if (this.isLoadingMore || !this.hasMore) return;
    this.isLoadingMore = true;
    const offset = this.featuredPosts.length + this.posts.length;
    app.store.find('discussions', this.requestParams(offset)).then(data => {
      var _data$payload$links;
      this.posts.push(...data);
      this.hasMore = (_data$payload$links = data.payload.links) != null && _data$payload$links.next ? true : null;
    }).catch(() => {}).finally(() => {
      this.isLoadingMore = false;
      m.redraw();
    });
  }
  title() {
    if (!m.route.param('slug')) {
      return m("h2", null, app.translator.trans('v17development-flarum-blog.forum.recent_posts'));
    }
    const tag = app.store.all('tags').filter(tag => tag.slug() === m.route.param('slug'));
    return m("h2", null, tag && tag[0] && tag[0].name(), m("small", null, ' ', "- ", m(Link, {
      href: app.route('blog')
    }, app.translator.trans('v17development-flarum-blog.forum.return_to_overview'))));
  }
  view() {
    const defaultImage = app.forum.attribute('blogDefaultImage') ? "url(".concat(app.forum.attribute('baseUrl') + '/assets/' + app.forum.attribute('blogDefaultImage'), ")") : null;
    let LanguageDropdown;
    if ('fof-discussion-language' in flarum.extensions) {
      var _flarum$extensions$fo;
      LanguageDropdown = (_flarum$extensions$fo = flarum.extensions['fof-discussion-language']) == null || (_flarum$extensions$fo = _flarum$extensions$fo.components) == null ? void 0 : _flarum$extensions$fo.LanguageDropdown;
    }
    return [app.forum.attribute('blogAddHero') == true && IndexPage.prototype.hero(), m("div", {
      className: 'FlarumBlogOverview'
    }, m("div", {
      className: 'container'
    }, m("div", {
      className: 'BlogFeatured'
    }, m("div", {
      className: 'BlogOverviewButtons'
    }, app.forum.attribute('canWriteBlogPosts') && m(Button, {
      className: 'Button',
      onclick: () => this.newArticle(),
      icon: 'fas fa-pencil-alt'
    }, app.translator.trans('v17development-flarum-blog.forum.compose.write_article')), this.languages !== null && this.languages.length >= 1 && m(LanguageDropdown, {
      selected: this.currentSelectedLanguage,
      onclick: language => {
        if (typeof language !== 'string') return;
        this.currentSelectedLanguage = language;
        m.route.set(document.location.pathname, {
          lang: language
        });
      }
    })), this.title(), m("div", {
      style: {
        clear: 'both'
      }
    }), m("div", {
      class: "BlogFeatured-list"
    }, this.isLoading && [...new Array(this.featuredCount).fill(undefined)].map(() => m("div", {
      class: "BlogFeatured-list-item BlogFeatured-list-item-ghost"
    }, m("div", {
      class: "BlogFeatured-list-item-details"
    }, m("h4", null, "\xA0"), m("div", {
      class: "data"
    }, m("span", null, m("i", {
      class: "far fa-wave"
    })))))), !this.isLoading && this.featuredPosts.length >= 0 && this.featuredPosts.map(article => m(FeaturedBlogItem, {
      article: article,
      defaultImage: defaultImage
    })))), m("div", {
      className: 'BlogScrubber'
    }, m("div", {
      className: 'BlogList'
    }, this.isLoading && [false, false, true, false].map(state => {
      return m("div", {
        className: "BlogList-item BlogList-item-".concat(state === true ? 'sized' : 'default', " BlogList-item-ghost")
      }, m("div", {
        className: 'BlogList-item-photo FlarumBlog-default-image'
      }), m("div", {
        className: 'BlogList-item-content'
      }, m("h4", null, "\xA0"), m("p", null, "\xA0"), m("div", {
        className: 'data'
      }, m("span", null, m("i", {
        className: 'far fa-wave'
      })))));
    }), !this.isLoading && this.posts.length >= 1 && this.posts.map(article => m(BlogOverviewItem, {
      article: article,
      defaultImage: defaultImage
    })), !this.isLoading && this.featuredPosts.length > 0 && this.hasMore === null && m("p", {
      className: 'FlarumBlog-reached-end'
    }, app.translator.trans('v17development-flarum-blog.forum.no_more_posts')), !this.isLoading && this.featuredPosts.length === 0 && this.posts.length === 0 && m("p", {
      className: 'FlarumBlog-reached-end'
    }, app.translator.trans('v17development-flarum-blog.forum.category_empty')), !this.isLoading && this.hasMore !== null && m("div", {
      className: 'FlarumBlog-reached-load-more'
    }, m(Button, {
      className: 'Button',
      onclick: () => this.loadMore(),
      icon: 'fas fa-chevron-down',
      loading: this.isLoadingMore
    }, app.translator.trans('core.forum.discussion_list.load_more_button')))), m("div", {
      className: 'Sidebar'
    }, this.showCategories && m(BlogCategories, null), this.showForumNav && m(ForumNav, null)))))];
  }
  newArticle() {
    let tags = [];

    // Get current category
    const currentCategory = app.store.getBy('tags', 'slug', m.route.param('slug'));
    if (currentCategory) {
      tags.push(currentCategory);
    }

    // Redirect to the composer
    m.route.set(app.route('blogComposer', {
      tags: tags.map(tag => tag.id()).join(),
      lang: this.languages.length > 0 ? this.currentSelectedLanguage : undefined
    }));
  }
}
flarum.reg.add('v17development-blog', 'forum/pages/BlogOverview', BlogOverview);